import React, { Component } from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import { imageSrc } from "../../util/PublicOrderAPI";
import "../shared/rtl-panel.css";

// Create / edit a category (CATEGORY_API.md §4.2 / §4.3). Only `name` is
// required (1–80). `image` is a free-form URL — there's no dedicated upload,
// so we just take a pasted link.
class ModelCategory extends Component {
    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const {
                        CT_modalOpen,
                        CT_editing,
                        CT_form,
                        CT_saving,
                        CT_formChange,
                        CT_saveCategory,
                        CT_CloseModal
                    } = value;

                    if (!CT_modalOpen) return null;

                    const isEdit = !!CT_editing;
                    const canSave = (CT_form.name || "").trim().length >= 1 && !CT_saving;

                    return (
                        <div className="rs-modal" dir="rtl" onClick={CT_CloseModal}>
                            <div
                                className="rs-modal__panel rs-modal__panel--md"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="rs-modal__head">
                                    <h5 className="rs-modal__title">
                                        <i className={`fas ${isEdit ? "fa-edit" : "fa-plus"}`}></i>
                                        {isEdit ? "دەستکاری جۆر" : "جۆری نوێ"}
                                    </h5>

                                    <div className="rs-modal__actions">
                                        <button
                                            className="rs-btn rs-btn--danger rs-btn--sm"
                                            onClick={CT_CloseModal}
                                        >
                                            <i className="fas fa-times"></i>
                                            داخستن
                                        </button>
                                    </div>
                                </div>

                                <div className="rs-modal__body">
                                    <div className="rs-form">
                                        <div className="rs-field rs-form__full">
                                            <label className="rs-field__label" htmlFor="ct-name">
                                                ناوی جۆر <span style={{ color: "#d33" }}>*</span>
                                            </label>
                                            <input
                                                id="ct-name"
                                                type="text"
                                                name="name"
                                                maxLength={80}
                                                value={CT_form.name}
                                                onChange={CT_formChange}
                                                placeholder="بۆ نموونە: شۆکولات"
                                                className="rs-input"
                                                autoFocus
                                            />
                                        </div>

                                        <div className="rs-field">
                                            <label className="rs-field__label" htmlFor="ct-sort">
                                                ڕیزبەندی
                                            </label>
                                            <input
                                                id="ct-sort"
                                                type="number"
                                                name="sortOrder"
                                                value={CT_form.sortOrder}
                                                onChange={CT_formChange}
                                                className="rs-input"
                                            />
                                        </div>

                                        <div className="rs-field">
                                            <label className="rs-field__label" htmlFor="ct-active">
                                                دۆخ
                                            </label>
                                            <label
                                                htmlFor="ct-active"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    height: "38px",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                <input
                                                    id="ct-active"
                                                    type="checkbox"
                                                    name="isActive"
                                                    checked={CT_form.isActive !== false}
                                                    onChange={CT_formChange}
                                                />
                                                {CT_form.isActive !== false ? "چالاک" : "ناچالاک"}
                                            </label>
                                        </div>

                                        <div className="rs-field rs-form__full">
                                            <label className="rs-field__label" htmlFor="ct-image">
                                                لینکی رەسم (ئارەزوومەندانە)
                                            </label>
                                            <input
                                                id="ct-image"
                                                type="text"
                                                name="image"
                                                value={CT_form.image}
                                                onChange={CT_formChange}
                                                placeholder="https://…"
                                                className="rs-input"
                                                dir="ltr"
                                            />
                                        </div>

                                        {CT_form.image ? (
                                            <div className="rs-form__full" style={{ textAlign: "center" }}>
                                                <img
                                                    src={imageSrc(CT_form.image)}
                                                    alt=""
                                                    className="rs-thumb"
                                                    style={{ width: "72px", height: "72px", margin: "0 auto" }}
                                                />
                                            </div>
                                        ) : null}

                                        <div
                                            className="rs-form__full"
                                            style={{ display: "flex", gap: "10px", justifyContent: "flex-start" }}
                                        >
                                            <button
                                                className="rs-btn rs-btn--primary"
                                                onClick={CT_saveCategory}
                                                disabled={!canSave}
                                            >
                                                {CT_saving ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                        پاشەکەوت...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save"></i>
                                                        پاشەکەوتکردن
                                                    </>
                                                )}
                                            </button>
                                            <button
                                                className="rs-btn rs-btn--ghost"
                                                onClick={CT_CloseModal}
                                                disabled={CT_saving}
                                            >
                                                هەڵوەشاندنەوە
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </ProductConsumer>
        );
    }
}

export default ModelCategory;
